import { Component, OnInit } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
	selector: 'app-premium',
	templateUrl: './premium.component.html',
	styleUrls: ['./premium.component.scss'],
})
export class PremiumComponent implements OnInit {
	enPremiumImage = 'assets/images/premium/en_banner_premiumads.png';
	kuPremiumImage = 'assets/images/premium/ku_banner_premiumads.png';
	arPremiumImage = 'assets/images/premium/ar_banner_premiumads.png';

	constructor(private api: ApiService, private route: ActivatedRoute, private title: Title, public locale: LocaleService) {}

	embedded: boolean = false;
	queryAdID: string;
	ad: Object;

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['ads']['ad']['n41'] + ' | ' + this.locale.translations['header']['n0']);
		this.route.queryParams.subscribe((queries: Params) => {
			this.queryAdID = queries['adID'];
			this.embedded = queries['embedded'];
		});
	}
}
